import React from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted Montserrat — replaces the Google Fonts @import that
// CSP blocks (style-src does not allow fonts.googleapis.com).
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';

// NOTE: the ~949KB base64 N-400 template (data/n400-base.js) is no longer
// eager-imported here. generateN400PDF() dynamic-imports it on first use, so
// it loads as its own chunk only when someone actually builds an N-400.

import NovoNavigator from './App.jsx';
import { ErrorBoundary } from './utils/error-boundary.jsx';
import { AuthProvider } from './hooks/useAuth.js';
import { OrgProvider } from './hooks/useOrg.js';
import { ToastProvider } from './hooks/useToast.js';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <OrgProvider>
          <AuthProvider>
            <NovoNavigator />
          </AuthProvider>
        </OrgProvider>
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
